import { UserPlus, Palette, TrendingUp, ArrowRight } from "lucide-react";

const STEP_ICONS = [UserPlus, Palette, TrendingUp];

export default function QuickStepsSection({ t }) {
  if (!t.quickSteps) return null;

  return (
    <section className="py-10 bg-gray-50 border-y border-gray-100" data-testid="quick-steps-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-0">
          {t.quickSteps.steps.map((step, i) => {
            const Icon = STEP_ICONS[i];
            return (
              <div key={i} className="flex items-center gap-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-[#CDA34F]/10 flex items-center justify-center flex-shrink-0">
                    <Icon className="w-5 h-5 text-[#CDA34F]" />
                  </div>
                  <div>
                    <p className="font-bold text-gray-900 text-sm">{step.title}</p>
                    <p className="text-xs text-gray-500 max-w-[140px]">{step.desc}</p>
                  </div>
                </div>
                {i < t.quickSteps.steps.length - 1 && (
                  <ArrowRight className="w-5 h-5 text-gray-300 flex-shrink-0 mx-4 hidden sm:block" />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
